"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteJSON = exports.postJSONGetFile = exports.postFile = exports.postJSON = exports.getFile = exports.getJSON = exports.timeoutRejection = void 0;
var either_1 = require("./either");
var wait = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var timeoutRejection = function (ms) {
    if (ms === void 0) { ms = 120000; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, wait(ms)];
                case 1:
                    _a.sent();
                    throw new Error("Timeout after " + ms + " ms");
            }
        });
    });
};
exports.timeoutRejection = timeoutRejection;
var getJSON = function (url, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, json, text, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, Promise.race([fetch(url, { headers: headers }), exports.timeoutRejection()])];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                return [2 /*return*/, either_1.Right(json)];
            case 3: return [4 /*yield*/, response.text()];
            case 4:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 5:
                e_1 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.getJSON = getJSON;
var getFile = function (url, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, text, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, Promise.race([fetch(url, { headers: headers }), exports.timeoutRejection(60000)])];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, either_1.Right(response)];
                }
                return [4 /*yield*/, response.text()];
            case 2:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 3:
                e_2 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getFile = getFile;
var postJSON = function (url, body, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType, text_1, json, text, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                return [4 /*yield*/, Promise.race([
                        fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: __assign({ 'Content-Type': 'application/json;charset=utf-8' }, headers),
                        }),
                        exports.timeoutRejection(),
                    ])];
            case 1:
                response = _a.sent();
                contentType = response.headers.get('content-type');
                if (!response.ok) return [3 /*break*/, 5];
                if (!(contentType === 'text/plain; charset=utf-8')) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                text_1 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text_1 || response.statusText })];
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                json = _a.sent();
                return [2 /*return*/, either_1.Right(json)];
            case 5: return [4 /*yield*/, response.text()];
            case 6:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 7:
                e_3 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 8: return [2 /*return*/];
        }
    });
}); };
exports.postJSON = postJSON;
var postFile = function (url, body, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType, text_2, json, text, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                return [4 /*yield*/, Promise.race([
                        fetch(url, {
                            method: 'POST',
                            body: body,
                            headers: headers,
                        }),
                        exports.timeoutRejection(60000),
                    ])];
            case 1:
                response = _a.sent();
                contentType = response.headers.get('content-type');
                if (!response.ok) return [3 /*break*/, 5];
                if (!(contentType === 'text/plain; charset=utf-8')) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                text_2 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text_2 || response.statusText })];
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                json = _a.sent();
                return [2 /*return*/, either_1.Right(json)];
            case 5: return [4 /*yield*/, response.text()];
            case 6:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 7:
                e_4 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 8: return [2 /*return*/];
        }
    });
}); };
exports.postFile = postFile;
var postJSONGetFile = function (url, body, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType, text, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, Promise.race([
                        fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: __assign({ 'Content-Type': 'application/json;charset=utf-8' }, headers),
                        }),
                        exports.timeoutRejection(),
                    ])];
            case 1:
                response = _a.sent();
                contentType = response.headers.get('content-type');
                if (response.ok) {
                    return [2 /*return*/, either_1.Right(response)];
                }
                return [4 /*yield*/, response.text()];
            case 2:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 3:
                e_5 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.postJSONGetFile = postJSONGetFile;
var deleteJSON = function (url, body, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var response, json, text, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, Promise.race([
                        fetch(url, {
                            method: 'DELETE',
                            body: JSON.stringify(body),
                            headers: __assign({ 'Content-Type': 'application/json;charset=utf-8' }, headers),
                        }),
                        exports.timeoutRejection(),
                    ])];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                json = _a.sent();
                return [2 /*return*/, either_1.Right(json)];
            case 3: return [4 /*yield*/, response.text()];
            case 4:
                text = _a.sent();
                return [2 /*return*/, either_1.Left({ status: response.status, message: text || response.statusText })];
            case 5:
                e_6 = _a.sent();
                return [2 /*return*/, either_1.Left({ status: '400', message: 'Během načítání dat nastala chyba' })];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.deleteJSON = deleteJSON;
